import styled from '@emotion/styled';
import { css } from '@emotion/react';
import {
  colors,
  spacing,
  getFontStyle,
  getBorderRadius,
} from '@cabonline/ui-shared';
import { labelHeight } from '../label';

const height = `${spacing.xl}px`;
const padding = `${spacing.xs}px`;
const iconHeight = `${spacing.xl}px`;
const iconWidth = `${spacing.xl}px`;
const maxWidth = '100%';

const baseStyles = css`
  width: 100%;
  min-height: ${height};
  padding: ${padding};
  border-radius: ${getBorderRadius('s')};
  border: 1px;
  border-style: solid;
  border-color: ${colors.gray2};
  background-color: ${colors.white};
`;

const hoverStyles = css`
  background-color: ${colors.gray4};
`;

const disabledStyles = css`
  color: ${colors.gray1};
  background-color: ${colors.gray3};
  cursor: not-allowed;
`;

const errorStyles = css`
  border-color: ${colors.red};
`;

const focusStyles = css`
  border-color: ${colors.black};
  outline: 1px solid ${colors.black};
`;

export const PressableIconWrap = styled.button`
  position: absolute;
  top: 0;
  right: 0;
  height: ${iconHeight};
  width: ${iconWidth};
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  &:focus {
    border: 2px solid ${colors.black};
    border-radius: ${getBorderRadius('s')};
    outline: none;
  }
`;

export const Container = styled.div`
  max-width: ${maxWidth};
`;

export const HelpText = styled.p`
  ${getFontStyle('s', 'semi')};
  color: ${colors.gray1};
  display: flex;
  align-items: center;
  width: 100%;
  line-height: ${labelHeight};
`;

export const ErrorWrap = styled.p`
  display: flex;
  flex-direction: row;
  align-items: center;
  line-height: ${labelHeight};
  margin-bottom: 4px;
`;

export const ErrorText = styled.p`
  ${getFontStyle('s', 'semi')};
  color: ${colors.red};
  padding-left: 4px;
`;

export const InputWrapper = styled.div`
  position: relative;
  max-width: ${maxWidth};
`;

type StyleProps = {
  disabled?: boolean;
  hasError?: boolean;
  readOnly?: boolean;
};

export const StyledTextInput = styled.input<StyleProps>`
  ${baseStyles};
  ${getFontStyle()};
  color: ${(p) => (p.readOnly ? colors.gray2 : colors.black)};
  cursor: ${(p) => (p.readOnly ? 'pointer' : 'caret')};
  &:hover {
    ${hoverStyles};
  }
  &:focus {
    ${focusStyles};
  }
  &:disabled {
    ${disabledStyles};
  }
  &::placeholder {
    color: ${colors.gray1};
  }
  ${(props) => props.hasError && errorStyles};
`;

export const StyledRequired = styled.span`
  color: ${colors.red};
`;
